import { MdLockOutline } from "react-icons/md";
import { RxAvatar } from "react-icons/rx";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Button1 from "../shared/Button1";

const NavbarButton = () => {

    const { isLoggedIn } = useAuth();

    return (
        <div className="navbarButton">
            {isLoggedIn ? (
                <NavLink to="/userdashboard" activeclassname="active">
                    <Button1>
                        <>
                            <RxAvatar />
                            Dashboard
                        </>
                    </Button1>
                </NavLink>
            ) : (
                <NavLink to="/login" activeclassname="active">
                    <Button1>
                        <>
                            <MdLockOutline />
                            Login
                        </>
                    </Button1>
                </NavLink>
            )}
        </div>
    )
}

export default NavbarButton